import { useCallback, useRef, type FocusEvent } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

export const ASSISTANT_INTERIM_TEXT_CLASS = 'assistant-interim-text'

export default function useAssistantThoughtFocus(canCollapse: boolean) {
  const toggleRef = useRef<HTMLButtonElement>(null)
  const focusedThoughtRef = useRef<HTMLElement | undefined>(undefined)
  const couldCollapseRef = useRef(canCollapse)

  const onFocusCapture = useCallback((event: FocusEvent<HTMLElement>) => {
    const target = event.target
    focusedThoughtRef.current = undefined
    if (target instanceof HTMLElement && target.closest(`.${ASSISTANT_INTERIM_TEXT_CLASS}`)) {
      focusedThoughtRef.current = target
    }
  }, [])

  const onBlurCapture = useCallback(() => {
    focusedThoughtRef.current = undefined
  }, [])

  useIsomorphicLayoutEffect(() => {
    const focusedThought = focusedThoughtRef.current
    if (canCollapse && !couldCollapseRef.current && focusedThought &&
      !focusedThought.isConnected && document.activeElement === document.body) {
      toggleRef.current?.focus({ preventScroll: true })
    }
    couldCollapseRef.current = canCollapse
  }, [canCollapse])

  return { toggleRef, onFocusCapture, onBlurCapture }
}
